module.exports = __webpack_public_path__ + "img/fahrzeugschein-alt.1717878.jpg";